<template>
    <div id="profile-page">
        <div class="page-heading">
            <h2 class="display-4 montserrat-bold mb-0">Notifications</h2>
            <div class="mt--2 heading-small">User Notification History</div>
        </div>

        <div class="bg-white shadow-reg list-container">
            <div class="header text-right">
                <button  @click="markAllRead" class="btn bg-white text-danger btn-link">
                    <i class="fa fa-eye mr-2"></i> Mark all as read
                </button>
            </div>
            <paginated-section class="card-list" :fetch-link="notificationFetchLink" paginate-path="data.result.notifications" ref="list" simplified>
                <template slot="loading">
                    <h3 class="text-muted m-0 pt-5 pb-5 text-center">
                        <i class="fas fa-spin fa-spinner mr-2"></i> Loading notifications
                    </h3>
                </template>
                <template slot="empty">
                    <h3 class="text-muted m-0 pt-5 pb-5 text-center">No notifications were found</h3>
                </template>
                <template slot="body" slot-scope="{ record }">
                    <notification-list-item :notif="record" />
                </template>

            </paginated-section>
        </div>

    </div>
</template> 
<script>
import '@styles/table.css';
import NotificationListItem from "./NotificationListItem";
import { route, get } from "@utils/network";

export default {
    name: "NotificationsListPage",

    components: { NotificationListItem },

    data: () => ({
        notificationFetchLink: route("notifications"),
    }),

    methods: {
        markAllRead() {
            this.isRequesting = true;
            get(route("notifications/read-all"))
                .then(response => this.markAsRead(response))
                .catch(error => this.failedToMarkAsRead(error))
                .finally(() => this.isRequesting = false);
        },
        markAsRead(response) {
            this.$refs.list.refresh();
        },
        failedToMarkAsRead(error) {
            this.promptErrors(error.response.data.message);
        },
    },

    mounted() {
        this.$emit("mounted");
    }
}
</script>
<style lang="css" scoped>
    .list-container .list-content-item {
        padding: 1rem 1.5rem !important;
        border-bottom: 1px solid rgba(0,0,0,0.1);
    }
    .list-container .list-content-item:last-child {
        margin-bottom: 1.5rem !important;
    }
    .list-container .list-content-item.unread {
        background-color: #f5f6f8 !important;
    }
</style>